export default "__VITE_ASSET__BOy4gH40__"